import * as T from '../constants/types';
import { Auth } from 'aws-amplify';
import { onSignIn } from './onSignIn';
import { throwError } from './throwNotification';

export const onResetDefaultPassword = () => async (dispatch, getState) => {
    const { loginForm: { login, password, newPassword } } = getState();
    try {
        const cognitoUser = await Auth.signIn(login, password);
        await Auth.completeNewPassword(cognitoUser, newPassword);
        dispatch({ type: T.RESET_DEFAULT_PASSWORD + T.SUCCESS });
        await dispatch(onSignIn());
    } catch (error) {
        dispatch(throwError(error, T.RESET_DEFAULT_PASSWORD + T.ERROR));
    }
};
